import React, { useState } from "react";
import { callApi } from "../actions/apiMethods";
import { token, setToLocalStorage } from "../libs/localStorage";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { RootContext } from "..";
import { observer } from "mobx-react-lite";
import LoadingButton from "@mui/lab/LoadingButton";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {jwtDecode} from "jwt-decode";
import { Link } from "react-router-dom";

export const Login = observer(() => {
	const navigate = useNavigate();

	const rootStore = useContext(RootContext);
	const store = rootStore.commonStore;

	const [loading, setLoading] = useState(false);

	const login = async (e) => {
		e.preventDefault();
		if (!formEntries.username || !formEntries.user_password) {
			toast.error("Missing fields");
			return;
		}
		setLoading(true);
		const res = await callApi("POST", "api/auth/login", formEntries);
		setLoading(false);
		if (!res) return;
		if (res.token) {
			const decoded = jwtDecode(res.token);
			if (decoded.otherTokens.length > 0) {
				decoded.otherTokens.forEach((element) => {
					setToLocalStorage(element.domain, element.token);
				});
				store.setOtherTokens(decoded.otherTokens);
			}
			token.set(res.token);
			navigate("/");
		}
	};

	const [formEntries, setFormEntries] = useState({
		username: "",
		user_password: ""
	});

	const setNewForm = (e) => {
		const { name, value } = e.target;
		setFormEntries((prev) => ({ ...prev, [name]: value }));
	};

	return (
	<>
  <ToastContainer
    position="bottom-right"
    hideProgressBar={true}
    autoClose={5000}
    theme="dark"
  />

  <div className="min-h-screen flex items-center justify-center bg-gray-100">
    <div className="bg-white text-gray-800 rounded-xl shadow-md p-8 w-full max-w-sm">
      <h3 className="text-xl font-semibold mb-2 text-center">Orbcomm Login</h3>
      <form className="space-y-4" onSubmit={(e) => login(e)}>
        <input
          type="text"
          name="username"
          id="username"
          value={formEntries.username}
          onChange={setNewForm}
          placeholder="Username"
          className="w-full px-4 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400 placeholder-gray-400"
        />

        <div className="relative">
          <input
            type="password"
            name="user_password"
            id="user_password"
            value={formEntries.user_password}
            onChange={setNewForm}
            placeholder="Password"
            className="w-full px-4 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400 placeholder-gray-400"
          />
          
        </div>

        <button
          type="submit"
          className="w-full bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 rounded transition-colors duration-200"
        >
          Login
        </button>
      </form>

      <div className="text-center text-xs text-gray-400 mt-4">RTS</div>
    </div>
  </div>
</>
	);
});
